export const AUDIENCE_INSIGHTS_HIGHEST_CAMPAIGNS_FEATURE_FLAG = 'HighestConvertingCampaignsSection';
export const AUDIENCE_INSIGHTS_CUSTOM_DEMOGRAPHICS_FEATURE_FLAG =
  'AudienceInsightsCustomDemographics';
export const AUDIENCE_INSIGHTS_METER_FEATURE_FLAG = 'AudienceInsightMeterUI';
export const CATALOG_IN_SEGMENTATION_FEATURE_FLAG = 'CatalogInSegmentation';
export const AUDIENCE_INSIGHTS_CUSTOM_EVENTS_MAPPING_FEATURE_FLAG = 'AudienceCustomEventMapping';
